import { ToolRegistry } from "./ToolRegistry";

export const toolRegistry = new ToolRegistry();

if (
  !toolRegistry.executeTool ||
  typeof toolRegistry.executeTool !== "function"
) {
  console.warn("Adding executeTool method to toolRegistry");
  toolRegistry.executeTool = async function (toolNameOrId, args) {
    const tool = this.tools?.get?.(toolNameOrId);
    if (!tool) {
      throw new Error(`Tool "${toolNameOrId}" not found in registry`);
    }

    if (!tool.execute || typeof tool.execute !== "function") {
      throw new Error(`Tool "${toolNameOrId}" does not have an execute method`);
    }

    return await tool.execute(args);
  };
}

export * from "./ImageGenTool";
export * from "./webSearchTool";

export async function registerAllTools() {
  try {
    const systemTools = await Promise.all([]);
    const generalTools = await Promise.all([]);
    const imageTools = await Promise.all([
      import("./ImageGenTool"),
      import("./imageEditTool"),
    ]);
    const webTools = await Promise.all([import("./webSearchTool")]);
    const codeTools = await Promise.all([]);
    const analysisTools = await Promise.all([]);
    const dataTools = await Promise.all([]);
    const legalTools = await Promise.all([]);
    const filesTools = await Promise.all([]);
    const context7Tools = await Promise.all([]);
    // Firecrawl tools removed - using unified web_search tool instead
    const binanceTools = await Promise.all([]);
    const puppeteerTools = await Promise.all([]);
    const visionTools = await Promise.all([]);

    const allToolModules = [
      ...systemTools,
      ...generalTools,
      ...imageTools,
      ...webTools,
      ...codeTools,
      ...analysisTools,
      ...dataTools,
      ...legalTools,
      ...filesTools,
      ...context7Tools,
      // firecrawlTools removed
      ...binanceTools,
      ...puppeteerTools,
      ...visionTools,
    ];

    const isValidToolObject = (obj) => {
      return (
        obj &&
        typeof obj === "object" &&
        obj.id &&
        obj.execute &&
        typeof obj.execute === "function"
      );
    };

    const extractToolFromModule = (module) => {
      if (module.default && isValidToolObject(module.default)) {
        return module.default;
      }

      const toolExport = Object.keys(module).find(
        (key) => key.includes("Tool") && isValidToolObject(module[key])
      );

      if (toolExport) {
        return module[toolExport];
      }

      const anyToolExport = Object.values(module).find(isValidToolObject);
      return anyToolExport;
    };

    let registeredCount = 0;
    for (const module of allToolModules) {
      try {
        const tool = extractToolFromModule(module);
        if (tool) {
          toolRegistry.register(tool, { skipDuplicates: true });
          registeredCount++;
        }
      } catch (error) {
        console.warn("Failed to register tool from module:", error);
      }
    }

    return {
      success: true,
      count: registeredCount,
    };
  } catch (error) {
    console.error("Failed to register all tools:", error);
    return {
      success: false,
      error: error.message,
    };
  }
}

export { imageGenTool } from "./ImageGenTool";

// Firecrawl tools removed - using unified web_search tool instead

export { BaseTool } from "./BaseTool";
export { imageEditTool } from "./imageEditTool";
export { webSearchTool } from "./webSearchTool";
